<template>
  <v-stepper v-model="e1" non-linear @reload="reloadstep($event)" id="inicioStepper">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1" editable>{{ $tc("dashboard.menu.createEvent.step_1_title") }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2" editable>{{ $tc("dashboard.menu.createEvent.step_2_title") }}</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3" >{{ $tc("dashboard.menu.createEvent.step_3_title") }}</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3.1" step="3.1" >{{ $tc("dashboard.menu.createEvent.step_3_1_title") }}</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3.2" step="3.2" >{{ $tc("dashboard.menu.createEvent.step_3_2_title") }}</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 6" step="6" editable>{{ $tc("dashboard.menu.createEvent.step_6_title") }}</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="e1 > 7" step="7" editable>{{ $tc("dashboard.menu.createEvent.step_7_title") }}</v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <v-card class="mb-12">
          <v-card-text class="text-left">
            <h2 class="text-center">
              <v-icon x-large color="black darken-2" class="icon_big">payment</v-icon>
              {{ $tc("dashboard.menu.createEvent.title_step_1") }}
            </h2>
            <p class="text-center">{{ $tc("dashboard.menu.createEvent.content_step_1") }}</p>
            <h4>
              <i class="far fa-clipboard"></i>
              {{ $tc("dashboard.menu.createEvent.subtitle_step_1") }}
            </h4>
            <p>{{ $tc("dashboard.menu.createEvent.content2_step_1") }}</p>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" class="btn_next" @click="nextStep(2)" large>
              <v-icon>done</v-icon>
              {{ $tc("dashboard.menu.createEvent.invoice_me") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="2">
        <v-card class="mb-12">
          <v-card-text class="text-center">
            <h2>{{ $tc("dashboard.menu.createEvent.title_step_2") }}</h2>
            <p>{{ $tc("dashboard.menu.createEvent.content_step_2") }}</p>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" class="btn_next mr-12" value="yes" @click="nextStep(3),step2='yes'" large>
              <v-icon>done</v-icon>
              {{ $tc("dashboard.menu.createEvent.yes") }}
            </v-btn>
            <v-btn color="primary" class="btn_next" value="no" @click="nextStep(6),step2='no'" large>
              <v-icon>close</v-icon>
              {{ $tc("dashboard.menu.createEvent.no") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-card class="mb-12">
          <v-card-text>
            <v-row>
              <v-col md="8" offset-md="2">
                <h3 class="text-left">{{ $tc("dashboard.menu.createEvent.subtitle_step_3") }}</h3>
                <p class="text-left">
                  <i class="far fa-info"></i>
                  &nbsp; {{ $tc("dashboard.menu.createEvent.content2_step_3") }}
                  <span class="text-danger">{{ $tc("dashboard.menu.createEvent.important_step_3") }}</span>
                </p>
                <p class="text-left mt-12">{{ $tc("dashboard.menu.createEvent.email_title") }}</p>
                <v-text-field type="email" :label="$tc('dashboard.menu.createEvent.email_label')" v-model="paypalEmail" :placeholder="$tc('dashboard.menu.createEvent.email_placeholder')"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12">
                <p>
                  <i class="far fa-info"></i>
                  &nbsp; {{ $tc("dashboard.menu.createEvent.content_step_3") }}
                </p>
              </v-col>
              <v-col md="6">
                <v-text-field v-model="fee" ref="fee" :label="$tc('dashboard.menu.createEvent.event_fee_label')" placeholder="1.50" type="number" @change="formatFee" :rules="feeRules"></v-text-field>
              </v-col>
              <v-col md="6">
                <v-select 
                  :label="$tc('dashboard.menu.createEvent.currency_label')" 
                  v-model="currency" 
                  :items="currency_items"
                  :no-data-text="$t('common.no_data')"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" class="btn_next" @click="nextStep(2)">
              <v-icon>arrow_back</v-icon>
              {{ $tc("dashboard.menu.createEvent.back") }}
            </v-btn>
            <v-btn color="primary" @click="nextStep(3.1)" class="btn_next ml-12">
              {{ $tc("dashboard.menu.createEvent.continue") }}
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="3.1">
        <v-card class="mb-12">
          <v-card-text>
            <v-row>
              <v-col md="12">
                <h3 class="titleClass titleRoom">
                  <i class="far fa-globe-americas"></i>
                  &nbsp; {{ $tc("dashboard.menu.createEvent.title_step_3_1") }}
                </h3>
                <p>
                  <i class="far fa-info"></i>
                  &nbsp;
                  {{ $tc("dashboard.menu.createEvent.content_step_3_1") }}
                </p>
              </v-col>
              <v-col md="6">
                <v-text-field :label="$tc('dashboard.menu.createEvent.address_label')" :placeholder="$tc('dashboard.menu.createEvent.address_placeholder')" v-model="address"></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field :label="$tc('dashboard.menu.createEvent.city_label')" :placeholder="$tc('dashboard.menu.createEvent.city_placeholder')" v-model="city"></v-text-field>
              </v-col>
              <v-col md="4">
                <v-select 
                  :label="$tc('dashboard.menu.createEvent.country_label')" 
                  :items="countryItems" 
                  @change="getStatesByCountry" 
                  v-model="country"
                  :no-data-text="$t('common.no_data')"
                ></v-select>
              </v-col>
              <v-col md="4">
                <v-select  
                  :label="$tc('dashboard.menu.createEvent.state_label')" 
                  :items="stateItems" 
                  v-model="state"
                  :no-data-text="$t('common.no_data')"
                ></v-select>
              </v-col>
              <v-col md="4">
                <v-text-field :label="$tc('dashboard.menu.createEvent.zip_label')" v-model="zip"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" class="btn_next" @click="nextStep(3)">
              <v-icon>arrow_back</v-icon>
              {{ $tc("dashboard.menu.createEvent.back") }}
            </v-btn>
            <v-btn color="primary" @click="nextStep(3.2)" class="btn_next ml-12">
              {{ $tc("dashboard.menu.createEvent.continue") }}
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="3.2">
        <v-card class="mb-12">
          <v-card-text>
            <v-row>
              <v-col md="12">
                <h3 class="titleClass titleRoom">
                  <i class="far fa-cogs"></i>
                  &nbsp; {{ $tc("dashboard.menu.createEvent.title_step_3_2") }}
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3">
                <v-datetime-picker 
                  v-model="regOpen" 
                  :label="$tc('dashboard.menu.createEvent.opening_datetime_label')" 
                  :time-picker-props="timeProps" 
                  date-format="yyyy-MM-dd"
                  :datePickerProps="{
                    locale: currentLocale,
                    'header-date-format': $datePicker.formatDateHeader,
                    'title-date-format': $datePicker.formatTitleDate,
                    'weekday-format': $datePicker.formatWeekday,
                    'month-format': $datePicker.formatMonth,
                  }"
                  :okText="$t('common.ok')"
                  :clearText="$t('common.clear')"
                ></v-datetime-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3">
                <v-datetime-picker 
                  v-model="regClose"
                  :label="$tc('dashboard.menu.createEvent.closing_datetime_label')" 
                  :time-picker-props="timeProps" 
                  date-format="yyyy-MM-dd"
                  :datePickerProps="{
                    locale: currentLocale,
                    'header-date-format': $datePicker.formatDateHeader,
                    'title-date-format': $datePicker.formatTitleDate,
                    'weekday-format': $datePicker.formatWeekday,
                    'month-format': $datePicker.formatMonth
                  }"
                  :okText="$t('common.ok')"
                  :clearText="$t('common.clear')"
                ></v-datetime-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3">
                <v-text-field :label="$tc('dashboard.menu.createEvent.max_registrations')" v-model="maxRegistrants" placeholder="10"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3">
                <v-text-field :label="$tc('dashboard.menu.createEvent.max_waiting')" v-model="waitLimit" placeholder="10"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3" style="text-align: initial;">
                <v-checkbox v-model="isMultiReg" :label="$tc('dashboard.menu.createEvent.multireg')"></v-checkbox>
                <span style="font-size:small;">{{ $tc("dashboard.menu.createEvent.multireg_span") }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3">
                <v-select 
                  :label="$tc('dashboard.menu.createEvent.select_lottery_label')" 
                  :items="lotteryselectItems" 
                  v-model="lotteryselect" 
                  item-text="name" 
                  item-value="val" 
                  @change="selectLottery"
                  :no-data-text="$t('common.no_data')"
                ></v-select>
                <p class="lotterystyle text-left" style="display: block" v-html="spanLottery"></p>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3" v-if="lotteryselect == 1">
                <v-select 
                  :label="$tc('dashboard.menu.createEvent.row_count_label')" 
                  :items="rowCountItems" 
                  v-model="rowCount" 
                  @change="changeCount"
                  :no-data-text="$t('common.no_data')"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" offset-md="3" v-if="lotteryselect == 1">
                <label for="letters">
                  <i class="far fa-text"></i>
                  {{ $tc("dashboard.menu.createEvent.letters_label") }}
                </label>
                <v-card flat class="letters">
                  <v-card-text class="p0">
                    <v-container fluid>
                      <v-row>
                        <v-col cols="12" sm="2" md="2" v-for="letter in letters" :key="letter.let" class="p0" id="chk_group">
                          <v-checkbox :label="letter.text" v-model="selected" :value="letter.let" hide-details @click="selLetter(letter.let)"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="12" v-if="error_msg.length > 0">
                <label class="error_ms">{{ error_msg }}</label>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" class="btn_next" @click="nextStep(3.1)">
              <v-icon>arrow_back</v-icon>
              {{ $tc("dashboard.menu.createEvent.back") }}
            </v-btn>
            <v-btn color="primary" class="btn_next ml-12" @click="nextStep(6)" >
              {{ $tc("dashboard.menu.createEvent.continue") }}
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content step="7">
        <v-form ref="form" @submit.prevent="createEvent">
          <v-card class="mb-12">
            <v-card-text>
              <h2 class="text-center">{{ $tc("dashboard.menu.createEvent.title_step_4") }}</h2>
              <p>{{ $tc("dashboard.menu.createEvent.content_step_4") }}</p>
              <v-row>
                <v-col md="4" offset-md="2">
                  <v-text-field v-model="form.eventName" :rules="rules.eventName" :label="$tc('dashboard.menu.createEvent.event_name_label')" :placeholder="$tc('dashboard.menu.createEvent.event_name_placeholder')" required></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-select 
                    :label="$tc('dashboard.menu.createEvent.timezone_label')" 
                    v-model="form.timeZone" 
                    :rules="rules.timeZone" 
                    item-text="text" 
                    item-value="id" 
                    :items="timeZoneItems" 
                    required
                    :no-data-text="$t('common.no_data')"
                  >
                    <template v-slot:item="{ item }">
                      <div v-html="item.text" />
                    </template>
                    <template v-slot:selection="{ item }">
                      <div v-html="item.text" />
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4" offset-md="2">
                  <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :label="$tc('dashboard.menu.createEvent.start_date_label')" v-model="form.startDate" :rules="rules.startDate" prepend-icon="event" readonly :value="fromStartDateDisp" v-on="on" required></v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="form.startDate" 
                      @input="startDateMenu = false, form.endDate == '' ? form.endDate = form.startDate : ''"
                      :header-date-format="$datePicker.formatDateHeader"
                      :title-date-format="$datePicker.formatTitleDate"
                      :weekday-format="$datePicker.formatWeekday"
                      :month-format="$datePicker.formatMonth"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col md="4">
                  <v-menu v-model="endDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field :label="$tc('dashboard.menu.createEvent.end_date_label')" v-model="form.endDate" :rules="rules.endDate" prepend-icon="event" readonly :value="fromEndDateDisp" v-on="on" required></v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="form.endDate" 
                      @input="endDateMenu = false"
                      :header-date-format="$datePicker.formatDateHeader"
                      :title-date-format="$datePicker.formatTitleDate"
                      :weekday-format="$datePicker.formatWeekday"
                      :month-format="$datePicker.formatMonth"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4" offset-md="2"  style="text-align: initial;">
                  <v-select 
                    :label="$tc('dashboard.menu.createEvent.select_tag_type_label')" 
                    :items="tag_types" item-text="name" item-value="val" 
                    @change="selectTagType" v-model="tagTypeSelect"
                    :no-data-text="$t('common.no_data')"
                  ></v-select>
                  <span style="font-size:small;">{{ span_tag_type }}</span>
                </v-col>
                <v-col md="4" v-if="tagTypeSelect == 2">
                  <v-checkbox :label="$tc('dashboard.menu.createEvent.text_span_tag_option_3')"></v-checkbox>
                </v-col>
                <v-col md="4" v-if="displayLinked">
                  <v-select 
                    :label="$tc('dashboard.menu.createEvent.display_linked_promoters')" 
                    v-model="displayLinkedPromoters" :items="displayLinkedItems" item-value="id"
                    :no-data-text="$t('common.no_data')"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="errorCreate">
                <v-col md="4" offset-md="2">{{ errorCreateMsg }}</v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="primary" class="btn_next" @click="nextStep(6)">
                <v-icon>arrow_back</v-icon>
                {{ $tc("dashboard.menu.createEvent.back") }}
              </v-btn>
              <!--<v-btn color="primary" class="btn_next ml-12" @click="nextStep(1)">
                <v-icon>cancel</v-icon>
                {{ $tc("dashboard.menu.createEvent.cancel_button") }}
              </v-btn>-->
              <v-btn color="primary" class="btn_next ml-12" type="submit" :disabled="!formIsValid">
                <v-icon>done</v-icon>
                {{ $tc("dashboard.menu.createEvent.create_button") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-stepper-content>
      <v-stepper-content step="6">
        <v-card class="mb-12">
          <v-card-text>
            <h2 class="text-center">
              <v-icon x-large color="black darken-2" class="icon_big">extension</v-icon>
              {{ $tc("dashboard.menu.createEvent.title_step_6") }}
            </h2>
            <p>{{ $tc("dashboard.menu.createEvent.content_step_6") }}</p>
            <v-container>
              <v-row>
                <v-col md="8" offset-md="2">
                  <v-select 
                    v-model="organization" :items="organizationsItems" 
                    item-value="id" item-text="name"  
                    @change="refreshOrganization"
                    :no-data-text="$t('common.no_data')"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="8" offset-md="2">
                  <v-checkbox v-model="isMembershipRequired" :disabled="organization == 0">
                    <template #label v-if="organization == 0"> <span style="color: rgba(0, 0, 0, 0.38);">{{$tc('dashboard.menu.createEvent.organization_chk1_label')}}</span></template>
                    <template #label v-else> <span >{{$tc('dashboard.menu.createEvent.organization_chk1_label')}}</span></template>
                  </v-checkbox>
                  <v-checkbox v-model="validMembership" :disabled="organization == 0">
                    <template #label v-if="organization == 0"> <span style="color: rgba(0, 0, 0, 0.38);">{{$tc('dashboard.menu.createEvent.organization_chk2_label')}}</span></template>
                    <template #label v-else> <span >{{$tc('dashboard.menu.createEvent.organization_chk2_label')}}</span></template>
                  </v-checkbox>
                  <v-checkbox v-model="managedByLL" :disabled="organization == 0">
                    <template #label v-if="organization == 0"> <span style="color: rgba(0, 0, 0, 0.38);">{{$tc('dashboard.menu.createEvent.organization_chk2_label')}}</span></template>
                    <template #label v-else> <span >{{$tc('dashboard.menu.createEvent.organization_chk2_label')}}</span></template>
                  </v-checkbox>
                  <!--<v-checkbox :label="$tc('dashboard.menu.createEvent.organization_chk4_label')" v-model="isBuyMembershipWithEvent" :disabled="organization == 0"></v-checkbox>-->
                </v-col>
                <v-col md="8" offset-md="2" >
                  <v-radio-group v-model="canSwitchClass">
                    <v-radio :label="$tc('dashboard.menu.createEvent.organization_rdb1_label')" :value="1" :disabled="organization == 0"></v-radio>
                    <v-radio :label="$tc('dashboard.menu.createEvent.organization_rdb2_label')" :value="2" :disabled="organization == 0"></v-radio>
                    <v-radio :label="$tc('dashboard.menu.createEvent.organization_rdb3_label')" :value="3" :disabled="organization == 0"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" class="btn_next" @click="nextStep(3.2)">
              <v-icon>arrow_back</v-icon>
              {{ $tc("dashboard.menu.createEvent.back") }}
            </v-btn>
            <v-btn color="primary" class="btn_next ml-12" @click="nextStep(7)">
              {{ $tc("dashboard.menu.createEvent.continue") }}
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import countryregion from "@/assets/data/countryregion.json";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  mixins: [apiCalls],
  name: "CreateEvents",
  data() {
    const step7Form = Object.freeze({
      eventName: "",
      startDate: "",
      endDate: "",
      timeZone: "US/Eastern",
    });
    return {
      form: Object.assign({}, step7Form),
      tagTypeSelect: 0,
      step7Form,
      e1: 1,
      selected: [],
      fee: Number.parseFloat(1.5).toFixed(2),
      currency: "CAD",
      currency_items: ["CAD", "USD", "EUR", "MXN"],
      address: process.env.VUE_APP_ENV != 'production' ? "7357 Main Street" : "",
      city: process.env.VUE_APP_ENV != 'production' ? "Ottawa" : "",
      country: "",
      state: "",
      zip: process.env.VUE_APP_ENV != 'production' ? "K1A 7A7" : "",
      regOpen: "",
      regClose: "",
      startD: "",
      regOpenDateMenu: false,
      regCloseDateMenu: false,
      startDateMenu: false,
      endDateMenu: false,
      maxRegistrants: 10,
      waitLimit: 10,
      isMultiReg: false,
      isPaymentRequired: "",
      rgOrganization: null,
      timeZoneItems: [],
      startDate: "",
      endDate: "",
      step2: "",
      displayLinked: false,
      lotteryselect: 1,
      rowCountItems: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      rowCount: null,
      letters: [],
      organizationGroupId: "",
      isMembershipRequired: null,
      validMembership: null,
      managedByLL: null,
      isBuyMembershipWithEvent: null,
      canSwitchClass: 3,
      disabledButton: true,
      timeProps: {
        format:"24hr"
      },
      countryItems: [],
      stateItems: [],
      organization: 0,
      eventName: "",
      userCurrent: "",
      error_msg: "",
      errorCreate: false,
      paypal_Email: ''
    };
  },
  mounted() {
    this.loadCountries();
    this.getOrganizations();
    this.getTimeZones();
    this.getUser();
    this.getLetters();
    this.displayLinkedVisible();
    this.paypal_Email = process.env.VUE_APP_ENV != 'production' ? this.$tc('dashboard.menu.createEvent.email_placeholder') : '';
  },
  methods: {
    async displayLinkedVisible(){
      var response = await this.api("get", "/api/v1/promoter/createEvent/showDisplayLinkedPromoter");
      if(response.message){
        this.displayLinked= true
      }
    },
    refreshOrganization(){
      if(this.organization == 0){
        this.isMembershipRequired = this.validMembership =  this.managedByLL = null
        this.canSwitchClass = 3
      }
    },
    formatFee(){
        this.fee = Number.parseFloat(this.fee).toFixed(2)
    },
    cleanAll() {
      this.paypalEmail = "";
      this.fee = Number.parseFloat(1.5).toFixed(2);
      this.currency = "CAD";
      this.address = "";
      this.city = "";
      this.country = "";
      this.state = "";
      this.zip = "";
      this.regOpen = "";
      this.regClose = "";
      this.startD = "";
      this.regOpenDateMenu = false;
      this.regCloseDateMenu = false;
      this.startDateMenu = false;
      this.endDateMenu = false;
      this.maxRegistrants = 10;
      this.waitLimit = 10;
      this.isMultiReg = false;
      this.lotteryselect = 1;
      this.rowCount = null;
      this.organizationGroupId = "";
      this.isMembershipRequired = null;
      this.validMembership = null;
      this.managedByLL = null;
      this.isBuyMembershipWithEvent = null;
      (this.canSwitchClass = 0), (this.disabledButton = true);
      this.organization = 0;
      this.eventName = "";
      this.userCurrent = "";
      this.error_msg = "";
      this.errorCreate = false;
      this.form.eventName = "";
      this.form.startDate = "";
      this.form.endDate = "";
      this.form.timeZone = "US/Eastern";
    },
    changeCount() {
      if (this.rowCount > 0){
        this.disabledButton = false
        this.selected = []
        this.letters.filter((x) => {
          if (x.sel == true) {
            x.sel = false;
          }
        });
        for(var i =0 ; i< this.rowCount; i++){
            this.selected[i] = ""+i
            this.letters[i].sel = true
        }
      } 
    },
    selLetter(_letter) {
      let letrasSel = this.letters.filter((x) => x.sel == true);
      let max=false, selectedT = [];
      if(letrasSel.length < this.rowCount){
        max=true
      }else{
        for(var i =0 ; i< this.rowCount; i++){
          if(this.selected[i])
            selectedT[i] = this.selected[i]
        }
        this.selected = selectedT 
      }
      this.letters.filter((x) => {
        if (x.let == _letter && x.sel == false && max) {
          x.sel = true;
        } else if (x.let == _letter && x.sel == true) {
          x.sel = false;
        }
      });

    },
    async getOrganizations() {
      var response = await this.api("get", "/api/v1/promoter/createEvent/getOrganizations");

      response.message.forEach(value => {
        this.organizationsItems.push({
          id: value.organizationId + "_" + value.id,
          name: value.name,
        });
      });
    },
    async getTimeZones() {
      const getTimeZones = await this.api("get", "/api/v1/promoter/eventDetails/getTimeZones");

      let arrayItems = [];

      Object.entries(getTimeZones.message).forEach(([key, value]) => {
        arrayItems.push({
          id: key,
          text: value,
        });
      });

      this.timeZoneItems = arrayItems;
    },
    async getUser() {
      const getUserCurrent = await this.api("get", "/api/v1/users/current");
      this.userCurrent = getUserCurrent.message;

      if(this.userCurrent.country || this.userCurrent.state){
        this.country = this.userCurrent.country
        if(this.userCurrent.state){
          this.getStatesByCountry();
          this.state = this.userCurrent.state
        }else{
          const getDomainParamState = await this.api("get", "/api/v1/livelaps/user/domainParam/defaultState");
          this.getStatesByCountry();
          this.state = getDomainParamState.message[0].value
        }
      }else{
          const getDomainParamCountry = await this.api("get", "/api/v1/livelaps/user/domainParam/defaultCountry");
          const getDomainParamState = await this.api("get", "/api/v1/livelaps/user/domainParam/defaultState");
          this.country = getDomainParamCountry.message[0].value
          this.getStatesByCountry();
          this.state = getDomainParamState.message[0].value
      }
    },
    async getLetters() {
      const getLetters = await this.api("get", "/api/v1/promoter/createEvent/getLetterRange");
      let arrayItems = [];

      Object.entries(getLetters.message).forEach(([value, key]) => {
        arrayItems.push({
          let: value,
          text: key,
          sel: false,
        });
      });
      this.letters = arrayItems;
    },
    loadCountries() {
      this.countryItems = countryregion.countries;
    },
    getStatesByCountry() {
      this.stateItems = countryregion.regions[this.country];
    },
    nextStep(n) {
      if(this.step2=='no' && n=='3.2'){
        n=2
      }
      if (n == 1) {
        this.cleanAll();
      }
      if (n == 6 && this.lotteryselect == 1 && this.rowCount == null && this.el == 3.2) {
        this.error_msg = this.$t("dashboard.menu.createEvent.error_row_count");
      } else {
        this.error_msg = "";
        this.e1 = n;
      }
      const element = document.getElementById("scrolling-techniques-7");
      element.scrollTop = 10;
      
     
    },
    async createEvent() {
      let letrasSel = this.letters.filter((x) => x.sel == true);
      let letrasMar = "";
      letrasSel.forEach((x) => {
        letrasMar += x.text + ",";
      });
      letrasMar = letrasMar.substr(0, letrasMar.length - 1);
      //Object
      let data = {
        eventName: this.form.eventName,
        startDate: this.form.startDate, //Review Format
        endDate: this.form.endDate, //Review Format
        systemId: 2,
        requireAma: 0,
        isMultiReg: this.isMultiReg ? 1 : 0,
        isPaymentRequired: 0,
        timezone: this.form.timeZone,
        userId: this.userCurrent.id,
        waitLimit: this.waitLimit,
        maxRegistrants: this.maxRegistrants,
        regOpt: this.step2 == "no" ? false : true,
        fee: this.fee,
        scoreType: 1,
        currency: this.currency.toLowerCase(),
        paymentType: "invoice",
        selectedCard: "",
        oneTimeTags: this.tagTypeSelect,
        registrationType: this.lotteryselect,
        organizationGroup: [this.organization],
        canSwitchClass: this.canSwitchClass,
        validMembership: this.validMembership ? 1 : 0,
        isMembershipRequired: this.isMembershipRequired ? 1 : 0,
        managedByLL: this.managedByLL ? 1 : 0,
        isBuyMembershipWithEvent: this.isBuyMembershipWithEvent ? 1 : 0,
        displayLinkedPromoters: this.displayLinkedPromoters,
      };

      this.country != "" ? (data.country = this.country) : "";
      this.city != "" ? (data.city = this.city) : "";
      this.state != "" ? (data.state = this.state) : "";
      this.regOpen != "" ? (data.regOpen = moment(this.regOpen).format("yyyy-MM-DD HH:mm")) : "";
      this.regClose != "" ? (data.regClose = moment(this.regClose).format("yyyy-MM-DD HH:mm")) : "";
      this.rowCount > 0 ? (data.rowCount = this.rowCount) : "";
      letrasMar.length > 0 ? (data.letters = letrasMar) : "";
      this.paypalEmail != "" ? (data.paypalEmail = this.paypalEmail) : "";
      this.address != "" ? (data.address = this.address) : "";
      this.zip != "" ? (data.zip = this.zip) : "";

      const response = await this.postApi("/api/v1/promoter/createEvent/", data);

      //Success
      if (response.success == 1) {
        let path = "/eventList" ;
        this.$router.push({
          path: path,
        });
      } else {
        this.errorCreate = true;
      }
    },
    selectTagType() {
      let _value = this.tagTypeSelect;
      if (_value == 0) {
        this.span_tag_type = this.$t("dashboard.menu.createEvent.span_tag_option_1");
      } else if (_value == 1) {
        this.span_tag_type = this.$t("dashboard.menu.createEvent.span_tag_option_2");
      } else if (_value == 2) {
        this.span_tag_type = this.$t("dashboard.menu.createEvent.span_tag_option_3");
      }
    },
    selectLottery() {
      let _value = this.lotteryselect;
      if (_value == 0) {
        this.spanLottery = '<i class="far fa-info"></i>&nbsp; ' + this.$t("dashboard.menu.createEvent.span_lottery");
      } else if (_value == 1) {
        this.spanLottery = '<i class="far fa-info"></i>&nbsp; ' + this.$t("dashboard.menu.createEvent.span_lottery_2");
      } else if (_value == 2) {
        this.spanLottery = '<i class="far fa-info"></i>&nbsp; ' + this.$t("dashboard.menu.createEvent.span_lottery_3");
      } else if (_value == 3) {
        this.spanLottery = '<i class="far fa-info"></i>&nbsp; ' + this.$t("dashboard.menu.createEvent.span_lottery_4");
      }
    },
  },
  computed: {
    ...mapGetters(["currentLocale"]),
    fromRegOpenDisp() {
      return this.regOpen;
    },
    fromRegCloseDisp() {
      return this.regClose;
    },
    fromStartDateDisp() {
      return this.startD;
    },
    fromEndDateDisp() {
      return this.endD;
    },
    formIsValid() {
      return this.form.eventName && this.form.startDate && this.form.endDate && this.form.timeZone;
    }, 
    rules() {
      return {
        eventName: [(val) => (val || "").length > 0 || this.$t("dashboard.menu.createEvent.event_name_required")],
        startDate: [(val) => (val || "").length > 0 || this.$t("dashboard.menu.createEvent.start_date_required")],
        endDate: [(val) => (val || "").length > 0 || this.$t("dashboard.menu.createEvent.end_date_required")],
        timeZone: [(val) => (val || "").length > 0 || this.$t("dashboard.menu.createEvent.timezone_required")],
      };
    },
    paypalEmail: {
      get() {
        return this.paypal_Email;
      },
      set(val) {
        this._paypal_Email = val;
      }
    },
    feeRules() {
      return [
        (v) => /^\d{0,20}(?:\.\d{1,2})?$/.test(v) || this.$t("dashboard.menu.createEvent.event_fee"),
      ];
    },
    paymentNotRequiredFromItems() {
      return [
        this.$t("dashboard.menu.createEvent.from_registration_date"), 
        this.$t("dashboard.menu.createEvent.from_event_date")];
    },
    lotteryselectItems() {
      return [
        {
          name: this.$t("dashboard.menu.createEvent.lottery_simple_number"),
          val: 0,
        },
        {
          name: this.$t("dashboard.menu.createEvent.lottery_lottery_style"),
          val: 1,
        },
        {
          name: this.$t("dashboard.menu.createEvent.lottery_no_assignment"),
          val: 2,
        },
        {
          name: this.$t("dashboard.menu.createEvent.lottery_participant_provided_number"),
          val: 3,
        },
      ];
    },
    spanLottery() {
      return '<i class="far fa-info"></i>&nbsp; ' + this.$t("dashboard.menu.createEvent.span_lottery_2");
    },
    tag_types() {
      return [
        {
          name: this.$t("dashboard.menu.createEvent.tag_type_option_1"),
          val: 0,
        },
        {
          name: this.$t("dashboard.menu.createEvent.tag_type_option_2"),
          val: 1,
        },
        {
          name: this.$t("dashboard.menu.createEvent.tag_type_option_3"),
          val: 2,
        },
      ];
    },
    span_tag_type() {
      return this.$t("dashboard.menu.createEvent.span_tag_option_1");
    },
    organizationsItems() {
      return [
        {
          id: 0,
          name: this.$t("dashboard.menu.createEvent.select_option_label"),
        },
      ];
    },
    displayLinkedItems() {
      return [
        {
          id: 0,
          text: this.$t("dashboard.menu.createEvent.no"),
        },
        {
          id: 1,
          text: this.$t("dashboard.menu.createEvent.yes"),
        },
      ];
    },
    displayLinkedPromoters() {
      return {
          id: 1,
          text: this.$t("dashboard.menu.createEvent.yes"),
      };
    },
    errorCreateMsg() { return this.$t("dashboard.menu.createEvent.error_create_msg"); }
  },
  props: {
    reinit: Number,
  },
};
</script>

<style>
.icon_big {
  font-size: 50px !important;
}
.btn_next {
  border: 1px solid #288283;
  color: #288283;
}
.letters {
  border: solid 1px #ccc !important;
}
.p0 {
  padding: 0;
}
#chk_group .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 4px;
  margin-left: 4px;
  margin-right: 4px;
}
#chk_group .v-input__slot > .v-label {
  left: -7px;
  top: 3px;
}
.error_ms {
  color: #ff0000b3 !important;
  font-size: 11px;
}

.theme--light.v-messages, .v-text-field__details {
    display: none;
}
</style>
